/*
  [CM] Swap a "sin caja".
  Por cada grupo completo de N perfumes de 30ml en el carrito (config.groupSize,
  default 4), N unidades se cambian a su producto duplicado "(Sin caja)": mismo
  handle y mismo SKU con sufijo (config.suffix, ej. "-2"). El resto se queda
  con caja: 5 unidades = 4 sin caja + 1 con caja; 8 = 8 sin caja. Si el conteo
  baja, las unidades sobrantes "sin caja" vuelven a la version con caja.
  Se trabaja por unidades: una linea con cantidad 2 puede quedar 1 con caja y
  1 sin caja (dos lineas).

  El duplicado se resuelve en el cliente con /products/<handle><sufijo>.js
  (cache por sesion), eligiendo la variante con el mismo SKU + sufijo o, si no
  hay, la que tenga el mismo valor de Tamaño. Nunca se toca una linea cuya
  contraparte no exista o no este disponible.

  Config en snippets/sincaja-swap-cm.liquid. Setting: Theme settings >
  Swap sin caja [CM]. Hooks de carrito copiados de bundle-auto-swap.js.
*/
(function () {
  'use strict';

  function init() {
    const configEl = document.getElementById('cm-sincaja-swap-config');
    if (!configEl) return;

    let config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }

    const GROUP_SIZE = parseInt(config.groupSize, 10) || 4;
    const SUFFIX = String(config.suffix || '-2');
    const SUFFIX_LC = SUFFIX.toLowerCase();
    const SIZE = normalize(config.sizeValue || '30ml');
    const DUP_PRODUCT_TYPE = String(config.dupProductType || '').trim().toLowerCase();
    const excludedHandles = new Set(
      (config.excludedHandles || []).map(function (h) {
        return String(h).trim().toLowerCase();
      }).filter(Boolean)
    );
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };

    let busy = false;
    let pending = false;
    let timer = null;
    const productCache = {};
    // handle del duplicado -> URL del producto original (para los links del carrito)
    const dupLinks = {};

    function normalize(value) {
      return String(value || '').toLowerCase().replace(/\s+/g, '');
    }

    function scheduleCheck() {
      clearTimeout(timer);
      timer = setTimeout(check, 350);
    }

    function hasSize(item) {
      const options = item.options_with_values || [];
      for (let i = 0; i < options.length; i++) {
        if (normalize(options[i].value) === SIZE) return true;
      }
      const values = item.variant_options || [];
      for (let j = 0; j < values.length; j++) {
        if (normalize(values[j]) === SIZE) return true;
      }
      return false;
    }

    function endsWithSuffix(value) {
      const str = String(value || '').toLowerCase();
      return str.length > SUFFIX_LC.length && str.slice(-SUFFIX_LC.length) === SUFFIX_LC;
    }

    function stripSuffix(value) {
      return String(value || '').slice(0, -SUFFIX.length);
    }

    function isDup(item) {
      if (!endsWithSuffix(item.handle) || !endsWithSuffix(item.sku)) return false;
      if (DUP_PRODUCT_TYPE && String(item.product_type || '').trim().toLowerCase() !== DUP_PRODUCT_TYPE) return false;
      return true;
    }

    function fetchProduct(handle) {
      if (!productCache[handle]) {
        productCache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
          headers: { Accept: 'application/json' }
        })
          .then(function (res) {
            return res.ok ? res.json() : null;
          })
          .catch(function () {
            return null;
          });
      }
      return productCache[handle];
    }

    function variantHasSize(variant) {
      return [variant.option1, variant.option2, variant.option3].some(function (option) {
        return normalize(option) === SIZE;
      });
    }

    // Variante destino para una linea: su duplicado (toDup) o su original.
    async function counterpart(item, toDup) {
      const handle = toDup ? item.handle + SUFFIX : stripSuffix(item.handle);
      const product = await fetchProduct(handle);
      if (!product || !product.variants || !product.variants.length) return null;
      const wantedSku = (toDup ? String(item.sku || '') + SUFFIX : stripSuffix(item.sku)).toLowerCase();
      let variant = null;
      if (wantedSku) {
        variant = product.variants.find(function (v) {
          return String(v.sku || '').toLowerCase() === wantedSku;
        }) || null;
      }
      if (!variant) {
        const sized = product.variants.filter(variantHasSize);
        if (sized.length === 1) variant = sized[0];
      }
      if (!variant || !variant.available) return null;
      return variant.id;
    }

    // Los links de las lineas "sin caja" deben llevar al producto original
    // (Kaching re-renderiza el drawer y vuelve a poner el href del duplicado,
    // por eso se reescribe en cada mutacion del drawer; setAttribute no
    // dispara el observer porque no observa atributos).
    function rewriteLinks() {
      const handles = Object.keys(dupLinks);
      if (!handles.length) return;
      const anchors = document.querySelectorAll('kaching-cart a[href*="/products/"]');
      for (let i = 0; i < anchors.length; i++) {
        const href = anchors[i].getAttribute('href') || '';
        const match = href.match(/\/products\/([^/?#]+)/);
        if (!match) continue;
        let handle = match[1];
        try {
          handle = decodeURIComponent(handle);
        } catch (e) {
          /* noop */
        }
        const target = dupLinks[handle];
        if (target && href !== target) anchors[i].setAttribute('href', target);
      }
    }

    async function updateDupLinks(dups) {
      const originals = await Promise.all(
        dups.map(function (item) {
          return counterpart(item, false);
        })
      );
      dups.forEach(function (item, i) {
        const url = root + 'products/' + stripSuffix(item.handle) + (originals[i] ? '?variant=' + originals[i] : '');
        dupLinks[item.handle] = url;
      });
      rewriteLinks();
    }

    async function check() {
      if (busy) {
        pending = true;
        return;
      }
      busy = true;
      try {
        const cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();

        const boxed = [];
        const dups = [];
        let total = 0;
        let dupUnits = 0;
        for (const item of cart.items) {
          if (excludedHandles.has(String(item.handle || '').toLowerCase())) continue;
          if (!(item.original_line_price > 0)) continue;
          if (!hasSize(item)) continue;
          total += item.quantity;
          if (isDup(item)) {
            dups.push(item);
            dupUnits += item.quantity;
          } else {
            boxed.push(item);
          }
        }

        // Precalentar la cache de contrapartes de todas las lineas de 30ml para
        // que el swap sea inmediato cuando se complete un grupo (fire-and-forget)
        boxed.forEach(function (item) {
          fetchProduct(item.handle + SUFFIX);
        });
        dups.forEach(function (item) {
          fetchProduct(stripSuffix(item.handle));
        });

        if (dups.length) await updateDupLinks(dups);

        // Unidades que deben estar "sin caja": solo grupos completos de N
        const targetDupUnits = Math.floor(total / GROUP_SIZE) * GROUP_SIZE;
        const delta = targetDupUnits - dupUnits;
        if (!delta) return;

        // delta > 0: convertir unidades con caja -> sin caja; delta < 0: al reves
        const toDup = delta > 0;
        const candidates = toDup ? boxed : dups;

        // Arma el cambio de `amount` unidades hacia la version destino. `left` > 0 = no alcanzaron
        // las unidades con version destino disponible.
        async function plan(cands, toDupFlag, amount) {
          const tg = await Promise.all(
            cands.map(function (item) {
              return counterpart(item, toDupFlag);
            })
          );
          const adds = [];
          const rem = {};
          let left = amount;
          for (let i = 0; i < cands.length && left > 0; i++) {
            const it = cands[i];
            if (!tg[i] || tg[i] === it.variant_id) continue;
            const units = Math.min(left, it.quantity);
            const add = { id: tg[i], quantity: units };
            if (it.properties && Object.keys(it.properties).length) add.properties = it.properties;
            adds.push(add);
            rem[it.key] = it.quantity - units;
            left -= units;
          }
          return { adds: adds, rem: rem, left: left };
        }

        let planned = await plan(candidates, toDup, Math.abs(delta));
        if (toDup && planned.left > 0) {
          // [CM 15-oct] El grupo no se puede completar sin caja (algun perfume no tiene su version sin caja
          // disponible): no se mezclan versiones en un mismo grupo. Si ya habia unidades sin caja, vuelven a con caja
          // para que todo el pedido salga igual (la promo 4x3 aplica a las dos versiones).
          if (!dupUnits) return;
          planned = await plan(dups, false, dupUnits);
        }
        const additions = planned.adds;
        const removals = planned.rem;
        if (!additions.length) return;

        // Primero agregar: si falla, el carrito queda intacto
        const addResponse = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: JSON_HEADERS,
          body: JSON.stringify({ items: additions })
        });
        if (!addResponse.ok) return;

        // Restar las unidades convertidas de las lineas de origen
        await fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: JSON_HEADERS,
          body: JSON.stringify({ updates: removals })
        });

        await refreshCartUI();
        // Re-verificar con el carrito post-swap
        pending = true;
      } catch (e) {
        // Error de red: dejar el carrito como esta
      } finally {
        busy = false;
        if (pending) {
          pending = false;
          scheduleCheck();
        }
      }
    }

    async function refreshCartUI() {
      if (document.querySelector('cart-items')) {
        window.location.reload();
        return;
      }
      const response = await fetch(root + '?sections=cart-drawer,cart-icon-bubble');
      if (!response.ok) return;
      const sections = await response.json();
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && sections['cart-drawer']) {
        drawer.renderContents({ sections: sections });
      } else if (sections['cart-icon-bubble']) {
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble) {
          const doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          const inner = doc.querySelector('.shopify-section');
          if (inner) bubble.innerHTML = inner.innerHTML;
        }
      }
    }

    // Firma del carrito segun el estado interno de Kaching (sincrono). Permite
    // ignorar el ruido del DOM del drawer (countdown "apartados", animaciones)
    // que muta cada segundo sin que el carrito cambie.
    let lastSignature = null;
    function kachingSignature() {
      try {
        const api = window.kachingCartApi;
        if (!api || typeof api.getCartData !== 'function') return null;
        const data = api.getCartData();
        if (!data || !Array.isArray(data.items)) return null;
        return data.items.map(function (item) {
          return item.key + ':' + item.quantity;
        }).join('|');
      } catch (e) {
        return null;
      }
    }

    // Kaching re-renderiza su drawer tras cualquier cambio de carrito (incluidos
    // los que hace via Storefront GraphQL sin pasar por fetch/XHR interceptados).
    new MutationObserver(function (mutations) {
      for (let i = 0; i < mutations.length; i++) {
        const target = mutations[i].target;
        const el = target.nodeType === 1 ? target : target.parentElement;
        if (el && el.closest && el.closest('kaching-cart')) {
          rewriteLinks();
          const signature = kachingSignature();
          if (signature !== null && signature === lastSignature) break;
          lastSignature = signature;
          if (!busy) scheduleCheck();
          break;
        }
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });

    const CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?/;

    function isCartGraphqlMutation(url, init) {
      if (url.indexOf('graphql') === -1) return false;
      const body = init && typeof init.body === 'string' ? init.body : '';
      return body.indexOf('cartLines') !== -1;
    }

    const originalFetch = window.fetch;
    window.fetch = function () {
      const result = originalFetch.apply(this, arguments);
      try {
        const target = arguments[0];
        const url = typeof target === 'string' ? target : (target && target.url) || '';
        if (CART_MUTATION.test(url) || isCartGraphqlMutation(url, arguments[1])) {
          result
            .then(function (res) {
              if (res.ok && !busy) scheduleCheck();
            })
            .catch(function () {});
        }
      } catch (e) {
        /* noop */
      }
      return result;
    };

    const originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (typeof url === 'string' && CART_MUTATION.test(url)) {
          this.addEventListener('load', function () {
            if (this.status >= 200 && this.status < 300 && !busy) scheduleCheck();
          });
        }
      } catch (e) {
        /* noop */
      }
      return originalOpen.apply(this, arguments);
    };

    // Cargas completas: formularios clasicos, back/forward
    scheduleCheck();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
